import FirebaseContext from './context';
import auth from './auth';
import firestore from './firestore';

const firebase = {
    auth: auth,
    firestore: firestore,
};
export {firebase};
export default FirebaseContext;
